import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { v4 as uuid } from 'uuid';
import act from '@flux/actions/actView';
import { Icon } from '@ts/storybook';
import { IconButton, Chip } from '@mui/material';
import { Modal, Typography } from '@ts/storybook';
import QueryPaginatedSelectionModal from './QueryPaginatedSelectionModal';
import { withTranslation } from 'react-i18next';

class MultiSelection extends React.Component {
  state = {
    showModal: false,
    fetchCompleted: false,
  };
  _selectedItems = Immutable.Map();
  _selectedItemsDataPath = `${this.props.itemsDataPath}_${uuid()}`;

  componentDidMount() {
    // fetch the selected items
    let { selectedIds, itemsFetchUrl } = this.props;
    if (Immutable.List.isList(selectedIds)) {
      selectedIds = selectedIds.toJS();
    }
    if (Array.isArray(selectedIds) && selectedIds.length) {
      const data = { ...this.props.fetchData, where: { isAlive: true } };
      data.where[this.props.columnToRetrieve] = selectedIds;
      act.fetch({
        url: itemsFetchUrl,
        dataPath: this._selectedItemsDataPath,
        data,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    let selectedIds = nextProps.selectedIds;
    let prevSelectedIds = this.props.selectedIds;
    if (Immutable.List.isList(selectedIds)) {
      selectedIds = nextProps.selectedIds.toJS();
    }
    if (Immutable.List.isList(this.props.selectedIds)) {
      prevSelectedIds = this.props.selectedIds.toJS();
    }
    if (!_.isEqual(prevSelectedIds, selectedIds)) {
      if (_.isEmpty(selectedIds)) {
        this._selectedItems = Immutable.Map();
      } else {
        act.fetch({
          url: this.props.itemsFetchUrl,
          dataPath: this._selectedItemsDataPath,
          data: {
            ...this.props.fetchData,
            where: {
              [this.props.columnToRetrieve]: selectedIds,
              isAlive: true,
            },
            filters: this.props.filters,
          },
        });
        if (this.props.clearSelectedItemsOnNewFetch) this._selectedItems = Immutable.Map();
        this.setState({ fetchCompleted: false });
      }
    } else {
      // When the initial fetch is done, create the map
      if (this.state.fetchCompleted == false) {
        const storeItems = nextProps.data.getIn([this._selectedItemsDataPath, 'data']);
        if (storeItems && nextProps.data.getIn([this._selectedItemsDataPath, 'state']) == 'IDLE') {
          // build the map
          storeItems.forEach(item => {
            this._selectedItems = this._selectedItems.set(item.get(this.props.columnToRetrieve), item);
          });
          this.setState({ fetchCompleted: true });
        }
      }
    }
  }

  render() {
    return (
      <>
        <Typography variant="h6" sx={{ fontWeight: '400' }}>
          {this.props.title}
          <IconButton
            color="primary"
            key="fabButton"
            disabled={this.props.disabled}
            onClick={() => {
              this.setState({ showModal: true });
            }}
          >
            <Icon icon="addBox" />
          </IconButton>
        </Typography>
        {this.props.upperExtraComponent}
        {this._renderSelected()}
        {this.props.lowerExtraComponent}
        {this._renderModal()}
      </>
    );
  }

  _renderSelected() {
    const chips = [];
    if (this._selectedItems) {
      this._selectedItems.forEach(item => {
        chips.push(
          <Chip
            className="m-1"
            label={this.props.fnChipCaption(item)}
            avatar={this.props.chipsAvatar}
            variant="outlined"
            key={item.get(this.props.columnToRetrieve)}
            onDelete={
              this.props.disabled
                ? null
                : () => {
                    this._selectedItems = this._selectedItems.delete(item.get(this.props.columnToRetrieve));
                    this._handleChangeSelected(this._selectedItems);
                  }
            }
          />
        );
      });
      /* if (!this.props.disabled) {
        chips.push(
          <IconButton
            aria-label="Add"
            color="primary"
            key={'fabButton'}
            onClick={() => {
              this.setState({ showModal: true });
            }}
          >
            <Icon icon="content-add" />
          </IconButton>
        );
      } */
    }

    return (
      <table>
        <tbody>
          <tr>
            <td>
              <div className="flex flex-wrap">{chips}</div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  _renderModal() {
    return (
      <Modal
        withHeader
        title="Add possible state"
        labelOk="Ok"
        open={this.state.showModal}
        onSubmit={this._closeModal}
        onClose={this._closeModal}
        fullWidth
        maxWidth="lg"
      >
        <QueryPaginatedSelectionModal
          {...this.props}
          isModal
          pkColumn={this.props.pkColumn}
          onChangeSelected={this._handleChangeSelected}
          selected={this._selectedItems}
        />
      </Modal>
    );
  }

  _closeModal = () => {
    this.setState({ showModal: false });
  };

  _handleChangeSelected = newSelected => {
    const { returnLogicalId } = this.props;
    this._selectedItems = newSelected;
    // reduce the quantity of data sended to parent component
    const [...reduced] = newSelected.keys();
    if (!returnLogicalId) {
      this.props.onChangeSelected(reduced);
    } else {
      this.props.onChangeSelected(reduced.map(itemId => newSelected.get(itemId).get('logicalId')));
    }
  };
}

MultiSelection.propTypes = {
  columns: PropTypes.array.isRequired,
  pkColumn: PropTypes.string.isRequired,
  itemsFetchUrl: PropTypes.string.isRequired,
  fnChipCaption: PropTypes.func.isRequired,
  onChangeSelected: PropTypes.func.isRequired,
  returnLogicalId: PropTypes.bool,
  filters: PropTypes.object,
  columnToRetrieve: PropTypes.string,
  clearSelectedItemsOnNewFetch: PropTypes.bool,
};

MultiSelection.defaultProps = {
  fetchData: {},
  filters: {},
  pkColumn: 'id', // From the columns passed as props
  columnToRetrieve: 'logicalId',
  zIndex: 1500,
  returnLogicalId: false,
  clearSelectedItemsOnNewFetch: false,
};

export default withTranslation()(MultiSelection);
